import { Sparkles, Search } from "lucide-react";

export function DocumentSuggestions({ checklist, docs, fileRef }) {
  if (!(checklist.length > 0 && docs !== null && docs.length > 0)) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="document-suggestions">
      {checklist.slice(0, 4).map((c, i) => (
        <button key={i} type="button" onClick={() => fileRef.current?.click()}
          className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-700 bg-white border border-dashed border-slate-300 hover:border-green-600 hover:text-green-800 rounded-full px-3 py-1.5 transition-colors"
          data-testid={`suggestion-${i}`}>
          <Sparkles className="w-3.5 h-3.5 text-green-700" aria-hidden="true" />
          {c.message}
        </button>
      ))}
    </div>
  );
}

export function DocumentFilters({ docs, search, onSearchChange, filterCategory, onFilterCategoryChange, filterStatus, onFilterStatusChange }) {
  if (!(docs !== null && docs.length > 0)) return null;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="documents-filters">
      <div className="relative">
        <Search className="w-4 h-4 text-slate-400 absolute left-2.5 top-2.5" aria-hidden="true" />
        <input type="search" value={search} onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Cerca per nome…" aria-label="Cerca documenti"
          className="pl-8 pr-3 py-2 text-sm rounded-md border border-slate-300 focus:border-green-600 focus:outline-none w-52"
          data-testid="documents-search" />
      </div>
      <select value={filterCategory} onChange={(e) => onFilterCategoryChange(e.target.value)}
        className="text-sm rounded-md border border-slate-300 px-2 py-2" data-testid="filter-category"
        aria-label="Filtra per categoria">
        <option value="">Tutte le categorie</option>
        <option value="ENVIRONMENTAL">Ambientale</option>
        <option value="SOCIAL">Sociale</option>
        <option value="GOVERNANCE">Governance</option>
        <option value="FINANCIAL">Finanziario</option>
        <option value="CORPORATE">Societario</option>
        <option value="OTHER">Altro</option>
      </select>
      <select value={filterStatus} onChange={(e) => onFilterStatusChange(e.target.value)}
        className="text-sm rounded-md border border-slate-300 px-2 py-2" data-testid="filter-status"
        aria-label="Filtra per stato">
        <option value="">Tutti gli stati</option>
        <option value="TO_REVIEW">Da verificare</option>
        <option value="EXTRACTION_COMPLETE">Dati estratti</option>
        <option value="VERIFIED">Verificati</option>
        <option value="PROCESSING_ERROR">Errori</option>
      </select>
    </div>
  );
}
